import { contactForm } from './contactForm';

const addContactFormScript = async (locale, formId, user) => {
  await esw.forms.create({
    solutionId: '8f7dee9e07e3a1600bd65db083b7ba708613f189',
    formId,
    language: locale,
    buildinelement: null,
  });

  if (formId === 7) {
    contactForm.base(user, locale);
  } else {
    contactForm[locale](user);
  }
};

const addEasiformShellScript = async () => {
  const scriptShell = document.createElement('script');
  scriptShell.src = 'https://aroma-zone.easiwebforms.net/static/shell.js';
  document.body.append(scriptShell);
  await new Promise((resolve) => {
    scriptShell.onload = resolve;
  });

  return true;
};

export { addEasiformShellScript, addContactFormScript };
